import Swal from 'sweetalert2';

const normalizeRole = (role) => String(role || '').trim().toLowerCase();

export async function triggerSendAlertAction({
  navigate,
  user,
  pageKey,
  jobPosition,
  targetRoute = '/employer-send-alert',
  targetRoles = ['employer'],
  targetRoleLabel = 'employer',
  registerDefaultTab = 'employer',
  loginDefaultTab = 'employer',
  prefillJobPositionOnContinue = true
}) {
  const role = normalizeRole(user?.role);
  const normalizedTargetRoles = targetRoles.map(normalizeRole);
  const hasRequiredRole = normalizedTargetRoles.includes(role);

  if (hasRequiredRole) {
    const params = new URLSearchParams({
      sourcePage: pageKey
    });

    if (prefillJobPositionOnContinue && jobPosition) {
      params.set('jobPosition', jobPosition);
    }

    navigate(params.toString() ? `${targetRoute}?${params.toString()}` : targetRoute);
    return;
  }

  if (!user?.id) {
    const result = await Swal.fire({
      title: '<div class="swal-custom-title">Please Register or Login</div>',
      text: `You must be registered and logged in as ${targetRoleLabel} to send alert${jobPosition ? ` for ${jobPosition}` : ''}`,
      icon: 'info',
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: 'Register',
      cancelButtonText: 'Login',
      denyButtonText: '<i class="bi bi-whatsapp"></i> Continue with WhatsApp',
      customClass: {
        popup: 'registration-popup',
        confirmButton: 'swal-register-btn',
        cancelButton: 'swal-login-btn',
        denyButton: 'swal-whatsapp-btn',
        actions: 'swal-actions-column'
      },
      buttonsStyling: false,
      showCloseButton: true,
      footer: '<div class="swal-footer-text">Registration helps prevent fake profiles</div>'
    });

    if (result.isConfirmed) {
      navigate('/register', { state: { defaultTab: registerDefaultTab } });
      return;
    }

    if (result.dismiss === Swal.DismissReason.cancel) {
      navigate('/login', { state: { defaultTab: loginDefaultTab } });
      return;
    }

    if (result.isDenied) {
      const message = encodeURIComponent('Hello, I want to register on GulfWorker.\nPlease guide me with the registration process');
      window.open(`https://wa.me/97477651422?text=${message}`, '_blank');
    }

    return;
  }

  await Swal.fire({
    icon: 'info',
    title: `${targetRoleLabel.charAt(0).toUpperCase()}${targetRoleLabel.slice(1)} Login Required`,
    text: `Please login with a ${targetRoleLabel} account to continue.`,
    confirmButtonText: 'Login'
  });

  navigate('/login', { state: { defaultTab: loginDefaultTab } });
}
